export default __webpack_public_path__ + "static/media/insta.30b397e6.svg";